import React from "react";
import { MdAddAPhoto } from "react-icons/md";

const PromoEditSection = ({ promo, setPromo }) => {
  const handlePromoFieldChange = (event) => {
    const { name, value } = event.target;
    setPromo((prevEntity) => ({ ...prevEntity, [name]: value }));
  };

  return !promo ? (
    <span>Loading...</span>
  ) : (
    <div className="flex flex-col justify-center items-center">
      <div className="w-2/3 h-52 border rounded-lg">
        {promo.image ? (
          <img
            src={promo.image}
            alt="imageUrl"
            className="w-full h-full object-cover rounded-lg"
          />
        ) : (
          <div className="flex flex-col items-center justify-center w-full h-full border-2 border-gray-300 border-dashed rounded-md bg-gray-50">
            <div className="flex item-center justify-center flex-col p-6 bg-white rounded-full bg-opacity-50">
              <MdAddAPhoto size="32" className="text-gray-600" />
            </div>
          </div>
        )}
      </div>
      <div className="flex flex-col w-full gap-4 mt-4">
        <label className="relative text-[10px] text-gray-700">
          Image
          <input
            name="image"
            onChange={handlePromoFieldChange}
            defaultValue={promo.image}
            placeholder="Promo image"
            className="custom-input"
            required
          />
        </label>
        <label className="relative text-[10px] text-gray-700">
          Title
          <input
            name="title"
            onChange={handlePromoFieldChange}
            defaultValue={promo.title}
            placeholder="Promo title"
            className="custom-input"
            maxLength={48}
            required
          />
        </label>
        <label className="relative text-[10px] text-gray-700">
          Text
          <textarea
            name="text"
            onChange={handlePromoFieldChange}
            value={promo.text}
            rows="6"
            className="custom-input"
            placeholder="Promo content"
            required
          />
        </label>
        <label className="relative text-[10px] text-gray-700">
          Link
          <input
            name="link"
            onChange={handlePromoFieldChange}
            defaultValue={promo.link}
            placeholder="Promo link"
            className="custom-input"
          />
        </label>
        <div className="flex gap-2 items-center">
          <input
            onChange={() => {
              setPromo((prevState) => ({
                ...prevState,
                isVisible: !promo.isVisible,
              }));
            }}
            checked={promo.isVisible}
            name="isVisible"
            type="checkbox"
            className="custom-checkbox"
          />
          <span className="text-sm">Visible</span>
        </div>
      </div>
    </div>
  );
};

export default PromoEditSection;
